import { Col, Input, Modal, Row } from "antd";
import React, { useContext } from "react";
import ProductCategoryContext from "../../../../contexts/product-category.context";
import { axios, getToken, URL_API } from "../../../../utils";

export default function ModalSubCategory() {
  const { state, dispatch } = useContext(ProductCategoryContext);

  const handleChange = (e) => {
    const { name, value } = e.target;

    dispatch({
      type: "CHANGE_FORM_VALUE",
      payload: {
        form: "sub_category",
        name,
        value,
      },
    });
  };

  const handleClickSave = () => {
    const { id, name } = state.form.sub_category;

    if (name === "") {
      return Modal.warning({
        title: "คุณกรอกข้อมูลไม่ครบถ้วน",
        content: "กรุณาตรวจสอบข้อมูลอีกครั้ง",
        cancelText: "ปิด",
      });
    }

    Modal.warning({
      title: "ยืนยันการทำรายการ",
      content: "คุณต้องการบันทึกข้อมูลหรือไม่",
      cancelText: "ปิด",
      okText: "บันทึก",
      onOk() {
        return new Promise((resolve, reject) => {
          axios({
            method: "POST",
            baseURL: URL_API,
            url: `/setting/master/sub-group${id === "" ? "" : `/${id}`}`,
            headers: { Authorization: "Bearer " + getToken() },
            data: {
              department_id: state.division?.id,
              division_id: state.department?.id,
              group_id: state.category?.id,
              name_en: name,
              name_local: name,
            },
          })
            .then((res) => {
              resolve("");
            })
            .catch((err) => {
              reject(
                err && err.response
                  ? err.response.data.message
                    ? err.response.data.message
                    : err.response.data
                  : err.message
              );
            });
        })
          .then((res) => {
            Modal.success({
              title: "สำเร็จ",
              content: "บันทึกข้อมูลเรียบร้อย",
              okText: "ปิด",
              onOk() {
                dispatch({ type: "CLOSE_MODAL" });
                dispatch({ type: "RELOAD", payload: "sub_category" });
              },
            });
          })
          .catch((reason) => {
            Modal.error({
              title: "ผิดพลาด",
              content: reason,
              okText: "ปิด",
            });
          });
      },
    });
  };

  return (
    <Modal
      title="กลุ่มสินค้าหลักย่อย"
      visible={state.modal.visible && state.modal.name === "sub_category"}
      cancelText="ปิด"
      okText="บันทึก"
      onCancel={() => {
        dispatch({ type: "CLOSE_MODAL" });
      }}
      onOk={handleClickSave}
    >
      <Row>
        <Col>
          <label>ชื่อกลุ่มสินค้าหลักย่อย</label>
          <Input
            placeholder="ชื่อกลุ่มสินค้าหลักย่อย"
            name="name"
            value={state.form.sub_category.name}
            onChange={handleChange}
          />
        </Col>
      </Row>
    </Modal>
  );
}
